import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { translate } from 'react-i18next';
import Media from 'react-media';
import validate from './reduxForm/validate';
import PropTypes from 'prop-types';
import { Button, Form, TextInput } from '@tillersystems/stardust';

import { Page, Theme } from '../../components';
import { FormGroupContainer } from './elements';

import * as CustomerInformationsActions from '../../services/DataServices/CustomerInformationService/actions';
import * as CustomerAddressActions from '../../services/DataServices/CustomerAddressService/actions';
import * as SFActions from '../../services/DataServices/SFDataService/actions';

import * as NavActions from '../../services/NavigationService/actions';

const { object, func } = PropTypes;

/**
 * Informations
 *
 * This component is in charge of displaying
 * a the user informations page
 *
 * @return {jsx}
 */

export class Informations extends Component {
  state = {
    stageValue: 'Page 2',
    stageNumber: 2,
  };

  /**
   * PropTypes validation
   */
  static propTypes = {
    customerInformations: object.isRequired,
    customerAddress: object.isRequired,
    initialize: func.isRequired,
    actions: object.isRequired,
    history: object.isRequired,
    form: object.isRequired,
    t: func.isRequired,
  };

  componentDidMount() {
    const { opportunity, actions } = this.props;
    const { stageValue, stageNumber } = this.state;

    if (opportunity._stageValue !== null) {
      actions.opportunityNeedUpdate(opportunity.getId(), stageValue, stageNumber);
    }

    actions.setCurrentStep(1);
  }

  handleSubmit = () => {
    // Store update
    const { form, actions, history } = this.props;
    const informationValue = {
      id: form.Information.values.id,
      name: form.Information.values.name,
      phone: form.Information.values.phone,
    };
    const addressValue = {
      id: form.Information.values.id,
      street: form.Information.values.street,
      city: form.Information.values.city,
      zipcode: form.Information.values.zipcode,
      country: form.Information.values.country,
    };
    actions.customerInformationsSaved(informationValue);
    actions.customerAddressSaved(addressValue);

    history.push('/order');
  };

  UNSAFE_componentWillMount() {
    const { customerInformations, initialize, customerAddress } = this.props;
    const { search, origin } = window.location;
    if (origin === 'http://onboarding.tillersystems.com') {
      document.location.replace(`http://onboarding-v2.tillersystems.com/${search}`);
    } else {
      initialize({
        id: customerInformations._id,
        name: customerInformations._name,
        phone: customerInformations._phone,
        street: customerAddress._street,
        city: customerAddress._city,
        zipcode: customerAddress._zipcode,
        country: customerAddress._country,
      });
    }
  }

  renderFormField = props => (
    <Form.Field {...props}>
      <TextInput fluid value={props.input.value} onChange={props.input.onChange} />
    </Form.Field>
  );

  render() {
    const { t } = this.props;

    return (
      <Page>
        <Page.Title>{t('informationsPage.heading')}</Page.Title>
        <Page.Paragraph>
          <div dangerouslySetInnerHTML={{ __html: t('informationsPage.content') }} />
        </Page.Paragraph>
        <Media query={{ maxWidth: Theme.breakpoints.md }}>
          {matches =>
            matches ? (
              <Form onSubmit={this.handleSubmit} name="form">
                <FormGroupContainer>
                  <Form.Group labelsWidth="100%">
                    <Field
                      label={t('informationsPage.fields.companyName')}
                      name="name"
                      type="text"
                      component={this.renderFormField}
                    />
                    <Field
                      label={t('informationsPage.fields.phoneNumber')}
                      name="phone"
                      type="number"
                      component={this.renderFormField}
                    />
                  </Form.Group>
                </FormGroupContainer>
                <FormGroupContainer>
                  <Form.Group>
                    <Field
                      label={t('informationsPage.fields.address')}
                      name="street"
                      type="text"
                      component={this.renderFormField}
                    />
                  </Form.Group>
                </FormGroupContainer>
                <FormGroupContainer>
                  <Form.Group>
                    <Field
                      label={t('informationsPage.fields.city')}
                      name="city"
                      type="text"
                      component={this.renderFormField}
                    />
                    <Field
                      label={t('informationsPage.fields.zipcode')}
                      name="zipcode"
                      type="number"
                      component={this.renderFormField}
                    />
                    <Field
                      label={t('informationsPage.fields.country')}
                      name="country"
                      type="text"
                      component={this.renderFormField}
                    />
                  </Form.Group>
                </FormGroupContainer>
                <FormGroupContainer>
                  <Form.Group>
                    <Form.Field>
                      <Button big primary fluid>
                        {t('informationsPage.button')}
                      </Button>
                    </Form.Field>
                  </Form.Group>
                </FormGroupContainer>
              </Form>
            ) : (
              <Form onSubmit={this.handleSubmit} name="form">
                <FormGroupContainer>
                  <Form.Group row labelsWidth="100%">
                    <Field
                      label={t('informationsPage.fields.companyName')}
                      name="name"
                      type="text"
                      component={this.renderFormField}
                    />
                    <Field
                      label={t('informationsPage.fields.phoneNumber')}
                      name="phone"
                      type="number"
                      component={this.renderFormField}
                    />
                  </Form.Group>
                </FormGroupContainer>
                <FormGroupContainer>
                  <Form.Group>
                    <Field
                      label={t('informationsPage.fields.address')}
                      name="street"
                      type="text"
                      component={this.renderFormField}
                    />
                  </Form.Group>
                </FormGroupContainer>
                <FormGroupContainer>
                  <Form.Group row>
                    <Field
                      label={t('informationsPage.fields.city')}
                      name="city"
                      type="text"
                      component={this.renderFormField}
                    />
                    <Field
                      label={t('informationsPage.fields.zipcode')}
                      name="zipcode"
                      type="number"
                      component={this.renderFormField}
                    />
                    <Field
                      label={t('informationsPage.fields.country')}
                      name="country"
                      type="text"
                      component={this.renderFormField}
                    />
                  </Form.Group>
                </FormGroupContainer>
                <FormGroupContainer>
                  <Form.Group>
                    <Form.Field>
                      <Button big primary fluid>
                        {t('informationsPage.button')}
                      </Button>
                    </Form.Field>
                  </Form.Group>
                </FormGroupContainer>
              </Form>
            )
          }
        </Media>
      </Page>
    );
  }
}

const mapStateToProps = state => ({
  customerInformations: state.customerInformations,
  customerAddress: state.customerAddress,
  form: state.form,
  opportunity: state.opportunity,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      ...NavActions,
      ...CustomerInformationsActions,
      ...CustomerAddressActions,
      opportunityNeedUpdate: SFActions.opportunityNeedUpdate,
    },
    dispatch,
  ),
});

const InformationsConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Informations);

const InformationsRF = reduxForm({
  form: 'Information',
  destroyOnUnmount: true,
  enableReinitialize: true,
  validate,
})(InformationsConnect);

export default translate(['translations', 'typology'])(InformationsRF);



// WEBPACK FOOTER //
// ./src/pages/Informations/index.js